import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import Grid from "@material-ui/core/Grid";
import CustomCheckbox from "components/General/Form/CustomCheckbox";

const ProfileCategoryGrid = (props) => {
  return (
    <div>
      {props.projectCat && props.projectCat.length > 0 ? (
        <div>
          <b>
            <TextTheme
              message="I will make the world a better place by supporting: "
              className="text_medium text_dark_blue text_semi_bold"
            />
          </b>
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
              direction="row"
              justify="flex-start"
              alignItems="flex-start"
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
                paddingTop: "20px",
              }}
            >
              {props.projectCat.map((elem) => (
                <Grid item xs={6} sm={3} md={3} key={elem}>
                  {props.selectedOptions.indexOf(elem) > -1 ? (
                    <CustomCheckbox
                      name={elem}
                      text={elem}
                      value={elem}
                      handleChange={props.handleChange}
                      defaultChecked={props.selectedOptions.indexOf(elem) > -1}
                    />
                  ) : (
                    <CustomCheckbox
                      name={elem}
                      text={elem}
                      value={elem}
                      handleChange={props.handleChange}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default ProfileCategoryGrid;
